import { v4 as uuid } from "uuid";
import { array } from "../array";

/**
 * Generates a random id based on the uuid v4 standard.
 * @see https://www.ietf.org/rfc/rfc4122.txt
 * @returns A random id.
 */
export function generateId() {
	return uuid();
}

/**
 * Generates a long random id by concatenating multiple uuid v4s.
 * @returns A random id, longer than a single uuid.
 */
export function generateExtraLongId() {
	return array(5, () => uuid())
		.join("")
		.replaceAll("-", "");
}
